import { useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { getUserStreamingSessions } from "@/services/apiProposal";

export function useGetStreamingProposals() {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["activeStreamingProposals"],
    queryFn: getUserStreamingSessions,
    // Refetch every 5 seconds only if we are currently streaming i.e. data exists and is non-empty.
    refetchInterval: (data) => (data?.length > 0 ? 5000 : false),

    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
    onSuccess: (data) => {
      if (data) {
        data?.forEach((element) => {
          const { proposal_id, search_type } = element;

          queryClient.setQueryData(
            ["proposalStreaming", proposal_id, search_type],
            (oldData) => ({ ...oldData, ...element })
          );
        });
      }
    },
  });
}
